export const LANGS = [
  { code: "bs", label: "Bosanski", short: "BS", dir: "ltr" },
  { code: "fr", label: "Français", short: "FR", dir: "ltr" },
  { code: "de", label: "Deutsch", short: "DE", dir: "ltr" },
  { code: "tr", label: "Türkçe", short: "TR", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
];

export const translations = {
  bs: {
    nav: { services: "Usluge", about: "O nama", reviews: "Recenzije", contact: "Kontakt" },
    hero: {
      badge: "35+ godina iskustva",
      locationTag: "Sarajevo i okolina",
      titleLines: [{ t: "GRADIMO" }, { t: "KAO ZA" }, { t: "SEBE.", accent: true }],
      subtitle:
        "Ekipa majstora s više od 35 godina iskustva. Bazen, krov, fasada, zidanje, beton — sve na jedan poziv. Sarajevo i okolina.",
      ctaCall: "Pozovite nas",
      ctaWhatsapp: "WhatsApp ponuda",
      scrollHint: "Istraži",
    },
    marquee: ["Kuće", "Bazeni", "Krovovi", "Fasade", "Zidanje", "Pločice", "Beton", "Temelji", "Armatura", "Adaptacije"],
    services: {
      eyebrow: "USLUGE",
      title: "Sve radove na jednom gradilištu",
      subtitle: "Od temelja do ključa — jedna ekipa, jedan odgovorni majstor. Nema podizvođača, nema izgovora.",
      items: [
        { title: "Kuće", desc: "Obiteljske kuće od temelja do ključa, nadogradnje spratova i komplet građevinski radovi po projektu." },
        { title: "Bazeni", desc: "Bazeni od armiranog betona — iskop, armatura, betoniranje, hidroizolacija i završna obrada." },
        { title: "Krovovi", desc: "Nova krovišta, pokrivanje crijepom, sanacija starih krovova, brdovi, koljenice i oplata." },
        { title: "Fasade", desc: "Toplinske i demit fasade — stiropor, mreža, ljepilo i završna boja po vašoj želji." },
        { title: "Zidanje", desc: "Zidarski radovi svih vrsta — opeka, blok, pregradni zidovi, nadstrešnice i manji objekti." },
        { title: "Pločice", desc: "Pločice, granit i veliki formati — kupatila, kuhinje, terase i stepenice, milimetarski tačno." },
        { title: "Beton i temelji", desc: "Temelji, ploče, međuspratne konstrukcije, podrum i svi betonski radovi na objektu." },
        { title: "Armatura", desc: "Vezanje armature po projektu i šrapel — čelik postavljen kako treba, na stoljeća." },
      ],
    },
    about: {
      eyebrow: "O NAMA",
      title: "Iskustvo koje se vidi u svakom zidu",
      p1: "BoomGradnja nije firma sa šaltera — to je ekipa majstora koja zanat nosi u rukama više od 35 godina. Od temelja do krova, od bazena do pločice, sve radimo sami, svojom opremom i svojim ljudima.",
      p2: "Gradilišta u Sarajevu i okolici su nam domaći teren: znamo svaki teren, svaki materijal i svaku komšijsku priču. Zato nam klijenti vraćaju povjerenje, a komšije donose nove projekte.",
      stats: [
        { v: "35+", l: "godina iskustva" },
        { v: "8", l: "vrsta radova" },
        { v: "4.8★", l: "prosječna ocjena klijenata" },
        { v: "1", l: "poziv do ponude" },
      ],
      processTitle: "Kako radimo",
      process: [
        { t: "Poziv ili WhatsApp", d: "Opišete radove, mi procijenimo i izađemo na teren." },
        { t: "Ponuda i termin", d: "Jasna cijena, rok i ekipa — bez skrivenih stavki." },
        { t: "Izvedba", d: "Radimo uredno, uz svakodnevni nadzor majstora." },
        { t: "Primopredaja", d: "Očistimo teren i predamo ključ u ruke." },
      ],
    },
    reviews: {
      eyebrow: "RECENZIJE",
      title: "Vi nas zovete — radimo ono što tražite.",
      subtitle: "Procitajte sami šta kažu naši klijenti.",
      regionLine: "SARAJEVO — ILIDŽA — VOGOŠĆA — HADŽIĆI — ILIJAŠ — HRASNICA — VISOKO — KISELJAK",
      tags: {
        pool: "Bazen", roof: "Krov", facade: "Fasada", house: "Kuća", masonry: "Zidanje",
        tiling: "Pločice", concrete: "Beton", rebar: "Armatura", renovation: "Adaptacija",
      },
    },
    contact: {
      eyebrow: "KONTAKT",
      title: "Imate projekt? Zovite danas.",
      subtitle: "Najbrže je telefon — javljamo se odmah. Ili pišite na WhatsApp, vraćamo se s ponudom istog dana.",
      callTitle: "Telefon",
      callDesc: "Zovete, dogovaramo besplatnu procjenu na terenu.",
      whatsappTitle: "WhatsApp",
      whatsappDesc: "Pošaljite fotografije i opis radova — ponuda isti dan.",
      regionLabel: "Radimo u Sarajevu i okolini — Ilidža, Vogošća, Hadžići, Ilijaš, Hrasnica, Visoko, Kiseljak i druge.",
      waMessage: "Pozdrav! Trebam ponudu za radove.",
      floatingCall: "Pozovi",
      floatingWhatsapp: "WhatsApp",
    },
    footer: {
      tagline: "Gradimo čvrsto. Gradimo za uvijek.",
      navTitle: "Navigacija",
      langTitle: "Jezici",
      contactTitle: "Kontakt",
      rights: "Sva prava zadržana.",
    },
  },

  fr: {
    nav: { services: "Services", about: "À propos", reviews: "Avis", contact: "Contact" },
    hero: {
      badge: "35+ ans d'expérience",
      locationTag: "Sarajevo et ses environs",
      titleLines: [{ t: "NOUS BÂTISSONS" }, { t: "COMME POUR" }, { t: "NOUS-MÊMES.", accent: true }],
      subtitle:
        "Une équipe d'artisans avec plus de 35 ans d'expérience. Piscine, toiture, façade, maçonnerie, béton — tout à un seul appel. Sarajevo et ses environs.",
      ctaCall: "Appelez-nous",
      ctaWhatsapp: "Devis WhatsApp",
      scrollHint: "Découvrir",
    },
    marquee: ["Maisons", "Piscines", "Toitures", "Façades", "Maçonnerie", "Carrelage", "Béton", "Fondations", "Armatures", "Rénovations"],
    services: {
      eyebrow: "SERVICES",
      title: "Tous les corps de métier sur un seul chantier",
      subtitle: "Des fondations à la clé — une équipe, un maître d'œuvre responsable. Pas de sous-traitants, pas d'excuses.",
      items: [
        { title: "Maisons", desc: "Maisons familiales de fondations à la clé, surélévations d'étage et tous travaux selon vos plans." },
        { title: "Piscines", desc: "Piscines en béton armé — terrassement, ferraillage, coulage, étanchéité et finitions." },
        { title: "Toitures", desc: "Charpentes neuves, couverture en tuiles, rénovation de toitures, pannes, chevrons et coffrage." },
        { title: "Façades", desc: "Isolation thermique par l'extérieur — polystyrène, treillis, colle et finition couleur au choix." },
        { title: "Maçonnerie", desc: "Maçonnerie de toutes sortes — briques, blocs, cloisons, auvents et petits ouvrages." },
        { title: "Carrelage", desc: "Carrelage, granit et grands formats — salles de bain, cuisines, terrasses et escaliers, au millimètre." },
        { title: "Béton et fondations", desc: "Fondations, dalles, planchers, sous-sol et tous les travaux de béton du bâtiment." },
        { title: "Armatures", desc: "Ferraillage selon plans et dallage — un acier posé comme il faut, pour des générations." },
      ],
    },
    about: {
      eyebrow: "À PROPOS",
      title: "Une expérience qui se voit dans chaque mur",
      p1: "BoomGradnja, ce n'est pas une entreprise à guichet — c'est une équipe d'artisans qui porte le métier dans ses mains depuis plus de 35 ans. Des fondations au toit, de la piscine au carrelage, tout est fait maison, avec notre matériel et nos hommes.",
      p2: "Sarajevo et ses environs sont notre terrain de jeu : nous connaissons chaque terrain, chaque matériau et chaque voisine. C'est pour cela que les clients reviennent et que les voisins nous apportent de nouveaux projets.",
      stats: [
        { v: "35+", l: "ans d'expérience" },
        { v: "8", l: "corps de métier" },
        { v: "4.8★", l: "note moyenne de nos clients" },
        { v: "1", l: "appel pour un devis" },
      ],
      processTitle: "Comment nous travaillons",
      process: [
        { t: "Appel ou WhatsApp", d: "Décrivez les travaux, nous estimons et venons sur place." },
        { t: "Devis et délai", d: "Prix clair, délai et équipe — sans frais cachés." },
        { t: "Réalisation", d: "Chantier propre, sous la surveillance quotidienne du maître." },
        { t: "Réception", d: "Nous nettoyons le site et vous remettons les clés." },
      ],
    },
    reviews: {
      eyebrow: "AVIS",
      title: "Vous nous appelez — nous faisons ce que vous demandez.",
      subtitle: "Lisez par vous-même les avis de nos clients.",
      regionLine: "SARAJEVO — ILIDŽA — VOGOŠĆA — HADŽIĆI — ILIJAŠ — HRASNICA — VISOKO — KISELJAK",
      tags: {
        pool: "Piscine", roof: "Toiture", facade: "Façade", house: "Maison", masonry: "Maçonnerie",
        tiling: "Carrelage", concrete: "Béton", rebar: "Armature", renovation: "Rénovation",
      },
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Un projet ? Appelez dès aujourd'hui.",
      subtitle: "Le plus rapide est le téléphone — nous répondons immédiatement. Ou écrivez sur WhatsApp, réponse avec devis le jour même.",
      callTitle: "Téléphone",
      callDesc: "Appelez, nous convenons d'une estimation gratuite sur place.",
      whatsappTitle: "WhatsApp",
      whatsappDesc: "Envoyez photos et description — devis le jour même.",
      regionLabel: "Nous travaillons à Sarajevo et autour — Ilidža, Vogošća, Hadžići, Ilijaš, Hrasnica, Visoko, Kiseljak et plus.",
      waMessage: "Bonjour ! Je souhaite un devis pour des travaux.",
      floatingCall: "Appeler",
      floatingWhatsapp: "WhatsApp",
    },
    footer: {
      tagline: "On bâtit solide. On bâtit pour toujours.",
      navTitle: "Navigation",
      langTitle: "Langues",
      contactTitle: "Contact",
      rights: "Tous droits réservés.",
    },
  },

  de: {
    nav: { services: "Leistungen", about: "Über uns", reviews: "Bewertungen", contact: "Kontakt" },
    hero: {
      badge: "35+ Jahre Erfahrung",
      locationTag: "Sarajevo und Umgebung",
      titleLines: [{ t: "WIR BAUEN" }, { t: "WIE FÜR" }, { t: "UNS SELBST.", accent: true }],
      subtitle:
        "Ein Team von Handwerkern mit über 35 Jahren Erfahrung. Pool, Dach, Fassade, Mauerwerk, Beton — alles auf einen Anruf. Sarajevo und Umgebung.",
      ctaCall: "Rufen Sie uns an",
      ctaWhatsapp: "WhatsApp-Angebot",
      scrollHint: "Entdecken",
    },
    marquee: ["Häuser", "Pools", "Dächer", "Fassaden", "Mauerwerk", "Fliesen", "Beton", "Fundamente", "Bewehrung", "Sanierungen"],
    services: {
      eyebrow: "LEISTUNGEN",
      title: "Alle Gewerke auf einer Baustelle",
      subtitle: "Von den Fundamenten bis zum Schlüssel — ein Team, ein verantwortlicher Meister. Keine Subfirmen, keine Ausreden.",
      items: [
        { title: "Häuser", desc: "Einfamilienhäuser von den Fundamenten bis zum Schlüssel, Aufstockungen und alle Arbeiten nach Plan." },
        { title: "Pools", desc: "Pools aus Stahlbeton — Aushub, Bewehrung, Gießen, Abdichtung und Fertigstellung." },
        { title: "Dächer", desc: "Neue Dachstühle, Ziegeleindeckung, Dacherneuerung, Pfetten, Sparren und Schalung." },
        { title: "Fassaden", desc: "WDVS-Fassaden — Styropor, Gewebe, Kleber und Schlussanstrich in Wunschfarbe." },
        { title: "Mauerwerk", desc: "Mauerarbeiten aller Art — Ziegel, Blöcke, Trennwände, Vordächer und Kleinbauten." },
        { title: "Fliesen", desc: "Fliesen, Granit und Großformate — Bäder, Küchen, Terrassen und Treppen, millimetergenau." },
        { title: "Beton und Fundamente", desc: "Fundamente, Platten, Decken, Keller und alle Betonarbeiten am Bau." },
        { title: "Bewehrung", desc: "Bewehrung nach Plan — Stahl richtig gesetzt, für Generationen." },
      ],
    },
    about: {
      eyebrow: "ÜBER UNS",
      title: "Erfahrung, die man in jeder Wand sieht",
      p1: "BoomGradnja ist kein Schalterunternehmen — wir sind ein Team von Handwerkern, die ihr Handwerk seit über 35 Jahren in den Händen tragen. Von den Fundamenten bis zum Dach, vom Pool bis zur Fliese: alles aus einer Hand.",
      p2: "Sarajevo und Umgebung sind unser Heimterrain: Wir kennen jeden Untergrund, jedes Material und jede Nachbarin. Deshalb kommen Kunden zurück und Nachbarn bringen neue Projekte.",
      stats: [
        { v: "35+", l: "Jahre Erfahrung" },
        { v: "8", l: "Gewerke" },
        { v: "4.8★", l: "durchschnittliche Kundenbewertung" },
        { v: "1", l: "Anruf bis zum Angebot" },
      ],
      processTitle: "So arbeiten wir",
      process: [
        { t: "Anruf oder WhatsApp", d: "Beschreiben Sie die Arbeiten, wir schätzen und kommen vorbei." },
        { t: "Angebot und Termin", d: "Klarer Preis, Termin und Team — ohne versteckte Posten." },
        { t: "Ausführung", d: "Sauber gearbeitet, mit täglicher Meisterkontrolle." },
        { t: "Übergabe", d: "Wir räumen die Baustelle und übergeben den Schlüssel." },
      ],
    },
    reviews: {
      eyebrow: "BEWERTUNGEN",
      title: "Sie rufen an — wir bauen, was Sie wünschen.",
      subtitle: "Lesen Sie selbst, was unsere Kunden sagen.",
      regionLine: "SARAJEVO — ILIDŽA — VOGOŠĆA — HADŽIĆI — ILIJAŠ — HRASNICA — VISOKO — KISELJAK",
      tags: {
        pool: "Pool", roof: "Dach", facade: "Fassade", house: "Haus", masonry: "Mauerwerk",
        tiling: "Fliesen", concrete: "Beton", rebar: "Bewehrung", renovation: "Sanierung",
      },
    },
    contact: {
      eyebrow: "KONTAKT",
      title: "Ein Projekt? Rufen Sie heute an.",
      subtitle: "Am schnellsten per Telefon — wir melden uns sofort. Oder schreiben Sie auf WhatsApp — Angebot noch am selben Tag.",
      callTitle: "Telefon",
      callDesc: "Anrufen, wir vereinbaren eine kostenlose Besichtigung.",
      whatsappTitle: "WhatsApp",
      whatsappDesc: "Fotos und Beschreibung senden — Angebot am selben Tag.",
      regionLabel: "Wir arbeiten in Sarajevo und Umgebung — Ilidža, Vogošća, Hadžići, Ilijaš, Hrasnica, Visoko, Kiseljak und mehr.",
      waMessage: "Hallo! Ich brauche ein Angebot für Bauarbeiten.",
      floatingCall: "Anrufen",
      floatingWhatsapp: "WhatsApp",
    },
    footer: {
      tagline: "Wir bauen solide. Wir bauen für immer.",
      navTitle: "Navigation",
      langTitle: "Sprachen",
      contactTitle: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
    },
  },

  tr: {
    nav: { services: "Hizmetler", about: "Hakkımızda", reviews: "Yorumlar", contact: "İletişim" },
    hero: {
      badge: "35+ yıl deneyim",
      locationTag: "Saraybosna ve çevresi",
      titleLines: [{ t: "BİR ÖMÜR" }, { t: "DURSUN DİYE" }, { t: "YAPIYORUZ.", accent: true }],
      subtitle:
        "35 yılı aşkın deneyimli usta ekibi. Havuz, çatı, cephe, duvar, beton — tek aramayla hepsi. Saraybosna ve çevresi.",
      ctaCall: "Bizi arayın",
      ctaWhatsapp: "WhatsApp teklifi",
      scrollHint: "Keşfet",
    },
    marquee: ["Evler", "Havuzlar", "Çatılar", "Cepheler", "Duvar örgüsü", "Fayans", "Beton", "Temeller", "İnşaat demiri", "Tadilat"],
    services: {
      eyebrow: "HİZMETLER",
      title: "Tüm işler tek bir şantiyede",
      subtitle: "Temelden anahtara — tek ekip, tek sorumlu usta. Taşeron yok, bahane yok.",
      items: [
        { title: "Evler", desc: "Temelden anahtara aile evleri, kat çıkarma ve projeye göre tüm inşaat işleri." },
        { title: "Havuzlar", desc: "Betonarme havuzlar — kazı, demir bağlama, döküm, su yalıtımı ve son kat." },
        { title: "Çatılar", desc: "Yeni çatı makasları, kiremit kaplama, eski çatı onarımı, kırış, makas ve kalıp işleri." },
        { title: "Cepheler", desc: "Mantolama ve dış cephe — styropor, file, yapıştırıcı ve dilediğiniz renkte son kat." },
        { title: "Duvar örgüsü", desc: "Her türlü duvar işi — tuğla, blok, ara duvarlar, sundurmalar ve küçük yapılar." },
        { title: "Fayans", desc: "Fayans, granit ve büyük ebatlar — banyo, mutfak, teras ve merdiven, milimetrik hassasiyetle." },
        { title: "Beton ve temeller", desc: "Temeller, plaklar, döşemeler, bodrum ve binadaki tüm beton işleri." },
        { title: "İnşaat demiri", desc: "Projeye göre demir bağlama — çelik doğru atılmış, nesneler boyu dayanacak." },
      ],
    },
    about: {
      eyebrow: "HAKKIMIZDA",
      title: "Her duvarda görülen tecrübe",
      p1: "BoomGradnja gişe firması değil — zanaatı 35 yıldan uzun süredir ellerinde taşıyan bir usta ekibi. Temelden çatıya, havuzdan fayansa her şeyi kendi ekip ve ekipmanımızla yapıyoruz.",
      p2: "Saraybosna ve çevresi bizim sahamız: her zemini, her malzemeyi, her mahalleyi tanırız. Bu yüzden müşteriler bize geri döner, komşular yeni işler getirir.",
      stats: [
        { v: "35+", l: "yıl deneyim" },
        { v: "8", l: "iş kolu" },
        { v: "4.8★", l: "ortalama müşteri puanı" },
        { v: "1", l: "aramayla teklif" },
      ],
      processTitle: "Nasıl çalışıyoruz",
      process: [
        { t: "Arama veya WhatsApp", d: "İşleri anlatın, biz keşfeder ve yerinde bakarız." },
        { t: "Teklif ve termin", d: "Net fiyat, termin ve ekip — sürpriz maliyet yok." },
        { t: "Uygulama", d: "Temiz iş, her gün usta kontrolünde." },
        { t: "Teslim", d: "Şantiyeyi temizler, anahtarı teslim ederiz." },
      ],
    },
    reviews: {
      eyebrow: "YORUMLAR",
      title: "Siz bizi arayın — biz istediğinizi yaparız.",
      subtitle: "Müşterilerimizin yorumlarını kendiniz okuyun.",
      regionLine: "SARAJEVO — ILIDŽA — VOGOŠĆA — HADŽIĆI — ILIJAŠ — HRASNICA — VISOKO — KISELJAK",
      tags: {
        pool: "Havuz", roof: "Çatı", facade: "Cephe", house: "Ev", masonry: "Duvar",
        tiling: "Fayans", concrete: "Beton", rebar: "Demir", renovation: "Tadilat",
      },
    },
    contact: {
      eyebrow: "İLETİŞİM",
      title: "Bir projeniz mi var? Bugün arayın.",
      subtitle: "En hızlısı telefon — hemen cevap veriyoruz. Ya da WhatsApp'tan yazın, aynı gün teklifle dönelim.",
      callTitle: "Telefon",
      callDesc: "Arayın, yerinde ücretsiz keşif ayarlayalım.",
      whatsappTitle: "WhatsApp",
      whatsappDesc: "Fotoğraf ve iş tanımı gönderin — aynı gün teklif.",
      regionLabel: "Saraybosna ve çevresinde çalışıyoruz — Ilidža, Vogošća, Hadžići, Ilijaš, Hrasnica, Visoko, Kiseljak ve dahası.",
      waMessage: "Merhaba! İşler için teklif almak istiyorum.",
      floatingCall: "Ara",
      floatingWhatsapp: "WhatsApp",
    },
    footer: {
      tagline: "Sağlam inşa ediyoruz. Kalıcı yapıyoruz.",
      navTitle: "Menü",
      langTitle: "Diller",
      contactTitle: "İletişim",
      rights: "Tüm hakları saklıdır.",
    },
  },

  ar: {
    nav: { services: "خدماتنا", about: "من نحن", reviews: "التقييمات", contact: "اتصل بنا" },
    hero: {
      badge: "أكثر من 35 سنة خبرة",
      locationTag: "ساراييفو وضواحيها",
      titleLines: [{ t: "نبني" }, { t: "كأنه" }, { t: "منزلنا.", accent: true }],
      subtitle:
        "فريق من الحرفيين بخبرة تتجاوز 35 سنة. مسبح، سقف، واجهة، بناء، خرسانة — كل ذلك بمكالمة واحدة. ساراييفو وضواحيها.",
      ctaCall: "اتصلوا بنا",
      ctaWhatsapp: "عرض عبر واتساب",
      scrollHint: "استكشف",
    },
    marquee: ["منازل", "مسابح", "أسقف", "واجهات", "بناء", "بلاط", "خرسانة", "أساسات", "حديد تسليح", "ترميم"],
    services: {
      eyebrow: "خدماتنا",
      title: "كل الأعمال في موقع واحد",
      subtitle: "من الأساس إلى المفتاح — فريق واحد، كبير حرفيين واحد. بلا مقاولين فرعيين ولا أعذار.",
      items: [
        { title: "المنازل", desc: "منازل عائلية من الأساس إلى المفتاح، إضافة طوابق وكل أعمال البناء حسب التصميم." },
        { title: "المسابح", desc: "مسابح من الخرسانة المسلحة — حفر، حديد، صبّ، عزل مائي وتشطيب نهائي." },
        { title: "الأسقف", desc: "هياكل أسقف جديدة، تغطية بالقرميد، ترميم الأسقف القديمة، عوارض ودعامات وقوالب." },
        { title: "الواجهات", desc: "واجهات عازلة للحرارة — ستايروفوم، شبك، لاصق وطلاء نهائي باللون الذي تختارونه." },
        { title: "البناء", desc: "أعمال بناء بكل أنواعها — طوب، بلوك، جدران فاصلة، مظلات ومباني صغيرة." },
        { title: "البلاط", desc: "بلاط، جرانيت وأحجام كبيرة — حمامات، مطابخ، شرفات وسلالم، بدقة المليمتر." },
        { title: "الخرسانة والأساسات", desc: "أساسات، بلاطات، أسقف بينية، قبو وجميع أعمال الخرسانة في المبنى." },
        { title: "حديد التسليح", desc: "ربط الحديد حسب التصميم — فولاذ موضوع كما يجب، ليديم لأجيال." },
      ],
    },
    about: {
      eyebrow: "من نحن",
      title: "خبرة تُرى في كل جدار",
      p1: "شركة BoomGradnja ليست شركة بروتوكولية — نحن فريق من الحرفيين يحملون الصنعة في أيديهم منذ أكثر من 35 سنة. من الأساس إلى السقف، ومن المسبح إلى البلاط، نفعل كل شيء بأيدينا وبعدتنا.",
      p2: "ساراييفو وضواحيها ملعبنا المألوف: نعرف كل أرض وكل مادة وكل حي. لذلك يعود إلينا الزبناء ويجلب لنا الجيران مشاريع جديدة.",
      stats: [
        { v: "35+", l: "سنة من الخبرة" },
        { v: "8", l: "فروع من الأعمال" },
        { v: "4.8★", l: "متوسط تقييم الزبناء" },
        { v: "1", l: "مكالمة حتى العرض" },
      ],
      processTitle: "كيف نعمل",
      process: [
        { t: "اتصال أو واتساب", d: "صف لنا الأعمال، نقدّر ونزور الموقع." },
        { t: "عرض وموعد", d: "سعر واضح، موعد وفريق — بلا بند خفي." },
        { t: "التنفيذ", d: "عمل مرتب تحت إشراف يومي من كبار الحرفيين." },
        { t: "التسليم", d: "ننظف الموقع ونسلّمك المفتاح." },
      ],
    },
    reviews: {
      eyebrow: "التقييمات",
      title: "اتصلوا بنا — وننفذ ما تطلبونه.",
      subtitle: "اقرأوا بأنفسكم آراء زبنائنا.",
      regionLine: "SARAJEVO — ILIDŽA — VOGOŠĆA — HADŽIĆI — ILIJAŠ — HRASNICA — VISOKO — KISELJAK",
      tags: {
        pool: "مسبح", roof: "سقف", facade: "واجهة", house: "منزل", masonry: "بناء",
        tiling: "بلاط", concrete: "خرسانة", rebar: "حديد التسليح", renovation: "ترميم",
      },
    },
    contact: {
      eyebrow: "اتصل بنا",
      title: "لديك مشروع؟ اتصل اليوم.",
      subtitle: "الأسرع هو الهاتف — نرد فوراً. أو راسلنا على واتساب ونعود بعرض في نفس اليوم.",
      callTitle: "الهاتف",
      callDesc: "اتصل ولنحدد معاينة مجانية في الموقع.",
      whatsappTitle: "واتساب",
      whatsappDesc: "أرسل الصور ووصف الأعمال — العرض في نفس اليوم.",
      regionLabel: "نعمل في ساراييفو وضواحيها — إيليدجا، فوغوشتشا، هادجيتشي، إيلياش، خراسنيتسا، فيسوكو، كيسيلياك وأكثر.",
      waMessage: "مرحباً! أحتاج عرض سعر للأعمال.",
      floatingCall: "اتصل",
      floatingWhatsapp: "واتساب",
    },
    footer: {
      tagline: "نبني بصلابة. نبني للأبد.",
      navTitle: "التنقل",
      langTitle: "اللغات",
      contactTitle: "التواصل",
      rights: "جميع الحقوق محفوظة.",
    },
  },
};
